import { useState } from "react";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import CreatePeriodForm from "./CreatePeriodForm";
import { useTranslation } from "react-i18next";
import ObjectivesTrackerCreateTriggerButton from "../detail/ObjectivesTrackerCreateTriggerButton";

const CreatePeriodDialog = ({ onSubmitHandler, trackerGoal }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const onSubmit = (formValues) => {
    setIsOpen(false);
    onSubmitHandler(formValues);
  };

  return (
    <DialogFormPanel
      trigger={<ObjectivesTrackerCreateTriggerButton />}
      title={t("objectivesTracker.createPeriodForm.title")}
      description={t("objectivesTracker.createPeriodForm.description")}
      content={
        <CreatePeriodForm
          onSubmitHandler={onSubmit}
          trackerGoal={trackerGoal}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreatePeriodDialog;
